import React, { useState, useEffect } from "react";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { useNavigate  } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal, Spinner } from "react-bootstrap";
import { getParentFacilities } from "../actions";
import Maintenance from "../../Maintenance";

/*** 
@purpose : Functional component
@Parameter : {props}
**/
function ParentFacilities(props) {
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [customerNotFound, setCustomerNotFound] = useState();
  const [details, setDetails] = useState([]);
  const [limit, setLimit] = useState(40);
  const [loading, setLoading] = useState(true);
  const [lazyLoading, setLazyLoading] = useState(false);
  const [maintenance, setMaintenance] = useState(false);
  const [orgId, setOrgId] = useState();
  const [total, setTotal] = useState(0);

  const [bun, setBUN] = useState("asc");
  const [dn, setDN] = useState("asc");

  useEffect(() => {
    async function fetchParentFacilities() {
      try {
        setOrgId(props.id);
        let body = {
          id: props.id,
          limit: 0,
          totalRecords: 0,
        };

        await getParentFacilities(body).then((res) => {
          setLoading(false);
          if (res.maintenanceWindowFlag) {
            setMaintenance(true);
          } else {
            setDetails(res && res.data.parentFacility);
            setTotal(
              res && res.data.parentFacility && res.data.parentFacility[0].total
            );
          }
        });
      } catch (error) {
        console.error("Error fetching parent facilities:", error);
        setLoading(false);
      }
    }
    
    fetchParentFacilities();
  }, []);

  /*** 
  @purpose : Change route
  @Parameter : {e, page}
  **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
    window.location.reload();
  };

  /*** 
  @purpose : Lazyload function
  @Parameter : {}
  **/
  // const handleContainerOnBottom = async () => {
  //   let body = {
  //     id: orgId,
  //     limit: details.length,
  //     totalRecords: total,
  //   };
  //   if (details.length < total && total >= 30) {
  //     await getParentFacilities(body).then((response) => {
  //       let list = [];
  //       list = details.concat(response.data.parentFacility);
  //       setDetails(list);
  //     });
  //     setLimit(limit + 10);
  //   }
  // };

  const loadRecords = async () => {
    let body = {
      id: orgId,
      limit: details.length,
      totalRecords: total,
    };
    if (details.length < total) {
      setLazyLoading(true);
      await getParentFacilities(body).then((response) => {
        let list = [];
        list = details.concat(response.data.parentFacility);
        setLazyLoading(false);
        setDetails(list);
      });
      setLimit(limit + 10);
    }
  };

  // const containerRef = useBottomScrollListener(handleContainerOnBottom);

  /*** 
@purpose : Handle sorting
@Parameter : {}
**/
  const handleSortingData = (obj) => {
    obj.column === "marketAuthorizationNameLocal" && setBUN(obj.sortOrder);
    obj.column === "unifiedCustomerCode" && setDN(obj.sortOrder);
    let list = compareBySortedData(obj);
    setDetails(list);
  };

  /*** 
  @purpose : Compare sorted data
  @Parameter : {}
  **/
  const compareBySortedData = (obj) => {
    const sorted = details.sort((a, b) => {
      const isReversed = obj.sortOrder === "asc" ? 1 : -1;
      let first = a[obj.column] ? a[obj.column] : "";
      let second = b[obj.column] ? b[obj.column] : "";
      return isReversed * first.localeCompare(second);
    });
    return sorted;
  };
  return (
    <>
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <>
          <div className="org-main">
            <div className="org-wrapper1">
              <h4 className="primary-title">
                {lang("OrganizationMenu.parentFacilities")}
              </h4>
              {details && details.length > 0 && (
                <p className="record-total">
                  {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
                  {details && details.length} / {total}
                </p>
              )}
              {details && details.length > 0 && (
                <>
                  <div
                    // ref={containerRef}
                    // onBottom={handleContainerOnBottom}
                    className="table-responsive mb-0 max-height hover-table"
                  >
                    <table className="table" aria-describedby="table">
                      <thead>
                        <tr>
                          <th scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "marketAuthorizationNameLocal",
                                sortOrder: bun === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("organizationDetails.product")}
                              <em class="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          <th scope="col"

                            onClick={() =>
                              handleSortingData({
                                column: "unifiedCustomerCode",
                                sortOrder: dn === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("organizationDetails.parentFacility")}
                              <em class="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {details &&
                          details.map((org,index) => {
                            return (
                              org && (
                                <tr
                                  key={index}
                                  onClick={(e) =>
                                    changeRoute(
                                      e,
                                      `/organizationInfo?orgId=${org.ID}`
                                    )
                                  }
                                >
                                  <td>
                                    {org && org.marketAuthorizationNameLocal
                                      ? org.marketAuthorizationNameLocal
                                      : ""}
                                  </td>
                                  <td>
                                    {/* (org && org.legacyUnifiedCustomerCode   /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                     /* ? org.legacyUnifiedCustomerCode         /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                                    {(org && org.unifiedCustomerCode      /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                      ? org.unifiedCustomerCode           /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                      : "") +
                                      " " +
                                      (org.customerNameLocalAbbr
                                        ? org.customerNameLocalAbbr
                                        : "")}
                                  </td>
                                </tr>
                              )
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {details.length < total && (
                    <div className="steps-action1 mt-4">
                      {lazyLoading && <Spinner animation="border" />}
                      <button
                        className="btn btn-primary"
                        onClick={loadRecords}
                        disabled={lazyLoading}
                      >
                        {lang("Buttons.loadMore")}
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          <Modal
            size="md"
            className="withdraw-modal"
            show={customerNotFound}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                <img src="images/warning2.svg" alt="Warning" /> Customer Not
                Found
              </div>
              <p className="mb-3">
                To search for customers, please go to{" "}
                <a
                  className="link"
                  onClick={(e) => {
                    changeRoute(e, "/organizationCustomer");
                  }}
                >
                  Organization Customer Inquiry
                </a>
              </p>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    details: state.organizationCustomer.orgDetails,
  };
};

export default ParentFacilities;
